<template>
  <div class="form">
    <el-table :data="table">
      <el-table-column
        label="名称"
        min-width="180">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="名称"
        min-width="180">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="名称"
        min-width="180">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.name }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  name: 'bluetooth-form',
  data() {
    return {
      table: [{ name: 'test' }],
    };
  },
};
</script>
<style lang="scss" scoped>
.form {
  margin: 40px;
}
</style>
